module.exports = __webpack_public_path__ + "static/media/ochrona-przed-wirusem.af4f55bb.jpg";